<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h550_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item
                    label="用户名称"
                    prop="userId"
                  >
                    <el-select
                      v-if="eventType !== 'view'"
                      v-model="dialogAddEditViewForm.userId"
                      filterable
                      clearable
                      placeholder="请选择用户"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in userOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.userName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="eventType === 'view'"
                :gutter="10"
              >
                <el-col :span="8">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditViewForm.provinceNames"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogAddEditViewForm.cityNames"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="eventType !== 'view'"
                :gutter="10"
              >
                <el-col :span="5">
                  <div class="search-box">
                    全部省区
                  </div>
                  <div class="left left-list-box">
                    <ul>
                      <li
                        v-for="(item,index) in provinceData"
                        :key="item.index"
                        :class="{'active':index==provinceCurrent}"
                        @dblclick="addToSetList(item, index, 'province')"
                        @click="leftCheckedFun(item, index, 'province')"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </el-col>
                <el-col style="width:85px;">
                  <div class="transfer-button">
                    <el-button
                      type="success"
                      plain
                      @click="addSetRightFun('province')"
                    >
                      添加
                    </el-button>
                    <el-button
                      type="warning"
                      plain
                      @click="deleteRightFun('province')"
                    >
                      删除
                    </el-button>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="search-box">
                    <i class="el-icon-success" />选择省区
                  </div>
                  <div class="right right-list-box">
                    <ul>
                      <draggable
                        :list="setProvinceData"
                        group="article"
                        class="dragArea"
                      >
                        <div
                          v-for="(element, index) in setProvinceData"
                          :key="index"
                          class="list-complete-item"
                          :class="{'active':index==setProvinceCurrent}"
                          @dblclick="deleteToSetList(element, index, 'province')"
                          @click="rightCheckedFun(element, index, 'province')"
                        >
                          <li class="employee">
                            {{ element.name }}
                          </li>
                        </div>
                      </draggable>
                    </ul>
                  </div>
                </el-col>

                <el-col :span="5">
                  <div class="search-box">
                    全部城市
                  </div>
                  <div class="left left-list-box">
                    <ul>
                      <li
                        v-for="(item,index) in cityData"
                        :key="item.index"
                        :class="{'active':index==cityCurrent}"
                        @dblclick="addToSetList(item, index, 'city')"
                        @click="leftCheckedFun(item, index, 'city')"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </el-col>
                <el-col style="width:85px;">
                  <div class="transfer-button">
                    <el-button
                      type="success"
                      plain
                      @click="addSetRightFun('city')"
                    >
                      添加
                    </el-button>
                    <el-button
                      type="warning"
                      plain
                      @click="deleteRightFun('city')"
                    >
                      删除
                    </el-button>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="search-box">
                    <i class="el-icon-success" />选择城市
                  </div>
                  <div class="right right-list-box">
                    <ul>
                      <draggable
                        :list="setCityData"
                        group="article"
                        class="dragArea"
                      >
                        <div
                          v-for="(element, index) in setCityData"
                          :key="index"
                          class="list-complete-item"
                          :class="{'active':index==setCityCurrent}"
                          @dblclick="deleteToSetList(element, index, 'city')"
                          @click="rightCheckedFun(element, index, 'city')"
                        >
                          <li class="employee">
                            {{ element.name }}
                          </li>
                        </div>
                      </draggable>
                    </ul>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { loadUserSelectDataApi } from '@/api/user'
import { initUserWorkBoardRegionApi, saveOrUpdateUserWorkBoardRegionApi } from '@/api/userWorkBoardRegion'
export default {
  components: { },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        userId: [ { required: true, message: '请选择用户', trigger: 'change' }]
      },
      userOptions: [],
      provinceData: [], // 省区数据源
      provinceChecked: null,
      provinceCurrent: -1,
      setProvinceData: [],
      setProvinceChecked: null,
      setProvinceCurrent: -1,
      cityData: [], // 城市数据源
      cityChecked: null,
      cityCurrent: -1,
      setCityData: [],
      setCityChecked: null,
      setCityCurrent: -1
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        
        this.userOptions = []
        this.provinceData = []
        this.provinceChecked = null
        this.provinceCurrent = -1
        this.setProvinceData = []
        this.setProvinceChecked = null
        this.setProvinceCurrent = -1
        this.cityData = []
        this.cityChecked = null
        this.cityCurrent = -1
        this.setCityData = []
        this.setCityChecked = null
        this.setCityCurrent = -1

        this.dialogAddEditViewForm = {          
          userId: '',
          userName: '',
          regionIds: '',
          regionNames: '',
          provinceIds: '',
          provinceNames: '',
          cityIds: '',
          cityNames: ''
        }

        if (this.eventType !== 'view') {
          this.initUserSelectData()
        }
        
        if (this.eventType !== 'add') {
          this.initPageData()          
        } else {
          this.initProvinceData()
        }
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initUserWorkBoardRegionApi({ id: this.dataId }).then(res => {
        const { data } = res
        for(let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id

        if (this.eventType === 'edit') {
          this.initProvinceData()
        }
        this.loading = false
      })
    },
    // 初始用户下拉数据
    initUserSelectData(){
      loadUserSelectDataApi({ status: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.userOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 获取省区清单
    initProvinceData () {
      loadAreaDataApi({ parentId: 1 }).then(response => {
        const { data } = response
        this.provinceData = data
        this.provinceChecked = null
        this.provinceCurrent = -1

        let provinceIds = ''
        data.forEach(item => {
          provinceIds += ',' + item.id
        })
        provinceIds = provinceIds.substring(1)
        this.initCityData(provinceIds)
      })
    },
    // 获取城市清单
    initCityData (provinceIds) {
      loadAreaDataApi({ parentIds: provinceIds }).then(response => {
        const { data } = response
        this.cityData = data
        this.cityChecked = null
        this.cityCurrent = -1
        if (this.eventType == 'add') {
          this.loading = false
        } else if (this.eventType === 'edit') {
          this.initCheckedProvinceAndCity()
        }
      })
    },
    // 修改时初始化选中的省区及城市
    initCheckedProvinceAndCity() {
      let _this = this
      // 初始化选中的省区
      if (_this.dialogAddEditViewForm.provinceIds) {
        let checkedProvinceIdArray = _this.dialogAddEditViewForm.provinceIds.split(',')
        _this.provinceData.forEach(item => {
          if (checkedProvinceIdArray.findIndex((value) => value == item.id) > -1) {
            _this.setProvinceData.push(item)
          }
        })
      }
      // 初始化选中的城市
      if (_this.dialogAddEditViewForm.cityIds) {
        let checkedCityIdArray = _this.dialogAddEditViewForm.cityIds.split(',')
        _this.cityData.forEach(item => {
          if (checkedCityIdArray.findIndex((value) => value == item.id) > -1) {
            _this.setCityData.push(item)
          }
        })
      }
    },

    leftCheckedFun (item, index, region) {
      if (region === 'province') {
        this.provinceCurrent = index
        this.provinceChecked = item
      } else if (region === 'city') {
        this.cityCurrent = index
        this.cityChecked = item
      }
    },
    rightCheckedFun (item, index, region) {
      if (region === 'province') {
        this.setProvinceCurrent = index
        this.setProvinceChecked = item
      } else if (region === 'city') {
        this.setCityCurrent = index
        this.setCityChecked = item
      }
    },
    addSetRightFun (region) {
      if (region === 'province') {
        if (!this.provinceChecked) {
          this.$message.error('请选择要添加的省区')
          return
        }
        let hasItem = false
        this.setProvinceData.forEach(item => {
          if (item.id === this.provinceChecked.id) {
            hasItem = true
          }
        })
        if (!hasItem) {
          this.setProvinceData.push(this.provinceChecked)
        }
      } else if (region === 'city') {
        if (!this.cityChecked) {
          this.$message.error('请选择要添加的城市')
          return
        }
        let hasItem = false
        this.setCityData.forEach(item => {
          if (item.id === this.cityChecked.id) {
            hasItem = true
          }
        })
        if (!hasItem) {
          this.setCityData.push(this.cityChecked)
        }
      }
    },
    deleteRightFun (region) {
      if (region === 'province') {
        if (!this.setProvinceChecked) {
          this.$message.error('请选择要删除的省区')
          return
        }
        let index = this.setProvinceData.indexOf(this.setProvinceChecked)
        if (index >= 0) {
          this.setProvinceCurrent = -1
          this.setProvinceData.splice(index, 1)
        }
      } else if (region === 'city') {
        if (!this.setCityChecked) {
          this.$message.error('请选择要删除的城市')
          return
        }
        let index = this.setCityData.indexOf(this.setCityChecked)
        if (index >= 0) {
          this.setCityCurrent = -1
          this.setCityData.splice(index, 1)
        }
      }
    },
    addToSetList (item, index, region) {
      this.leftCheckedFun(item, index, region)
      this.addSetRightFun(region)
    },
    deleteToSetList (item, index, region) {
      this.rightCheckedFun(item, index, region)
      this.deleteRightFun(region)
    },
    
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      let _this = this
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          if (_this.setProvinceData.length === 0 && _this.setCityData.length === 0) {
            this.$message({ message: '请选择用户的移动端区域设置', type: 'warning' })
            return
          }

          _this.$confirm(
            (_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '移动端区域设置','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              _this.loading = true
              _this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      let _this = this
      let regionIds = '', regionNames = '', provinceIds = '', provinceNames = '', cityIds = '', cityNames = ''      
      _this.setProvinceData.forEach(item => {
        regionIds += ',' + item.id
        regionNames += ',' + item.name
        provinceIds += ',' + item.id
        provinceNames += ',' + item.name
      })
      _this.setCityData.forEach(item => {
        regionIds += ',' + item.id
        regionNames += ',' + item.name
        cityIds += ',' + item.id
        cityNames += ',' + item.name
      })
      _this.dialogAddEditViewForm.regionIds = regionIds.length > 0 ? regionIds.substring(1) : ''
      _this.dialogAddEditViewForm.regionNames = regionNames.length > 0 ? regionNames.substring(1) : ''
      _this.dialogAddEditViewForm.provinceIds = provinceIds.length > 0 ? provinceIds.substring(1) : ''
      _this.dialogAddEditViewForm.provinceNames = provinceNames.length > 0 ? provinceNames.substring(1) : ''
      _this.dialogAddEditViewForm.cityIds = cityIds.length > 0 ? cityIds.substring(1) : ''
      _this.dialogAddEditViewForm.cityNames = cityNames.length > 0 ? cityNames.substring(1) : ''

      saveOrUpdateUserWorkBoardRegionApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>

.search-box{
  width:100%;
  margin-bottom:10px;
  margin-top: 10px;
  .el-icon-success{
    color:#67c23a;
    font-size: 16px;
    vertical-align: middle;
    display: inline-block;
    margin-right:5px;
    margin-top:-2px;
  }
}
.left {
  width:100%;
  height: 250px;
  border: 1px solid #ccc;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-bottom:10px;
}
.right {
  width: 100%;
  height: 250px;
  border: 1px solid #ccc;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-bottom:10px;
}
.left {
  padding: 5px 0;
}
.left li{
  padding:0 5px;
}
.left-list-box {
  overflow-x: hidden;
  overflow: auto;
}
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
  line-height: 20px;
}
.transfer-button {
  width: 70px;
  float: left;
  padding-top:120px;
  text-align: center;
}
.transfer-button .el-button {
  margin: 10px 0;
  flex:1
}
.right {
  width: 100%;
}
.right-list,
.list-complete-item {
   width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
  display: flex;
  overflow-x: hidden;

}
.right-list li ,.list-complete-item li{
  padding: 0 5px;
  margin: 0;
  line-height: 24px;
  border-bottom: 1px solid #ccc;
  flex:1;
}
li.order {
 flex:0 1 60px;
 width:60px;
  border-right: 1px solid #ccc;
}
 li.employee {
  border-right: 1px solid #ccc;
  text-align: center;
}
.right-list>li{
  background: #efefef;
}
.li:hover {
  background: #b2e1ff;
}
.active {
  background: #7fceff;
}
.right-list-box {
  background: #67c23a1a;
  overflow-x: hidden;
  overflow: auto;
}
</style>
